import { memo } from 'react'

import { jsonLD } from '@/shared/integrations/microdata'
import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { TFaqItem } from '@/shared/types/deprecated-types'

import { Accordion } from './Accordion/Accordion'

import cl from './FaqSection.module.scss'

export type FaqSectionProps = {
	items: TFaqItem[]
}

export const FaqSection = memo(({ items }: FaqSectionProps): JSX.Element => {
	const faqSchema = jsonLD.getFAQSchema(items)

	return (
		<>
			{/* Microdata jsonLd (FAQPage) */}
			<script type="application/ld+json" data-label="FAQPage" dangerouslySetInnerHTML={createMarkup(faqSchema)} />
			{items &&
				items.map(({ question, answer }, index) => {
					return (
						<div className={cl.main} key={index}>
							<Accordion title={<div className={cl.title} dangerouslySetInnerHTML={createMarkup(question)} />}>
								<div className={cl.value} dangerouslySetInnerHTML={createMarkup(answer)} />
							</Accordion>
						</div>
					)
				})}
		</>
	)
})
